import { Box, Stack, Typography, TextField, Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import Iconify from 'src/components/iconify';
import { useJobCreationContext } from 'src/sections/job2/hooks/use-job-creation-context';
import { getPublicApplyLink } from 'src/services/role.service';
import TrackYourApplications from './track-your-applications';

export default function JobApplyLink() {
  // context
  const {
    jobId: savedJobId,
    jobApplyLink,
    setJobApplyLink,
  } = useJobCreationContext();
  const { enqueueSnackbar } = useSnackbar();

  // states
  const [copyButtonClicked, setCopyButtonClicked] = useState(false);

  // functions
  const handleCopyClick = async () => {
    try {
      setCopyButtonClicked(true);
      enqueueSnackbar('Copied');
      await navigator.clipboard.writeText(jobApplyLink);
      setJobApplyLink(jobApplyLink);
      setTimeout(() => {
        setCopyButtonClicked(false);
      }, 2000);
    } catch (err) {
      console.error('Unable to copy link to clipboard:', err);
    }
  };

  const handleLinkChange = event => {
    setJobApplyLink(event.target.value);
  };

  // effects
  useEffect(() => {
    if (!jobApplyLink) {
      getPublicApplyLink(savedJobId)
        .then(res => {
          if (res.success) {
            const link =
              process.env.REACT_APP_APPLY_JOB_BASE_URL +
              (res?.body?.links?.APPLY_JOB ?? '');
            setJobApplyLink(link);
          } else throw new Error(res.message);
        })
        .catch(err => {
          console.error(err);
          enqueueSnackbar('Something went wrong while creating job link', {
            variant: 'error',
          });
        });
    }
  }, [enqueueSnackbar, jobApplyLink, savedJobId, setJobApplyLink]);

  return (
    <Box
      borderRadius="6px"
      bgcolor={theme => theme.palette.common.white}
      border={theme => `1px solid ${theme.palette.border.primaryBlack2}`}
      px="16px"
      py="24px"
    >
      <Stack spacing="28px">
        <Stack spacing="12px">
          <Typography variant="subheading1">Job Apply Link</Typography>
          <Typography
            variant="input"
            color={theme => theme.palette.content.primaryBlack3}
          >
            You can use the link provided below to set up the application link
            on your desired job portal.
          </Typography>
        </Stack>
        <Stack spacing="16px">
          <Stack
            direction="row"
            alignItems="center"
            spacing="12px"
            sx={{ width: '100%' }}
          >
            <TextField
              fullWidth
              placeholder="https://hireintel.app/jobpostinglink-software-engineeri..."
              value={jobApplyLink}
              onChange={handleLinkChange}
            />
            <Button
              variant="contained"
              startIcon={
                !copyButtonClicked && (
                  <Iconify color="white" icon="tabler:copy" />
                )
              }
              onClick={handleCopyClick}
            >
              {copyButtonClicked ? 'Copied' : 'Copy link'}
            </Button>
          </Stack>
          <TrackYourApplications />
        </Stack>
      </Stack>
    </Box>
  );
}
